module.exports = __webpack_public_path__ + "assets/to-conquer.102dd8d9.svg";